import { useContext } from 'react'

import { ToastContext } from '~/src/components/generic/Toast/context'

/**
 * Hook to use the Toast context
 * @returns Toast context
 */
const useToast = () => useContext(ToastContext)

export default useToast
